import React, { useState } from 'react';
import styles from './TextConfirmationModal.module.css';
import classnames from 'classnames';
import { FloComponentProps } from 'components';
import { FloModal } from 'components/FloModal';
import { FloButton, FloButtonType } from 'components/FloButton';
import { useTranslation } from 'react-i18next';
import { Container, Row } from 'react-bootstrap';
import _ from 'lodash';

type AcceptMetadata = { [key: string]: any };

interface TextConfirmationModalProps extends FloComponentProps {
  show:                         boolean;
  acceptMetadata:               AcceptMetadata;
  onHide:                       () => void;
  title:                        string;
  description:                  string | React.ReactNode;
  actionText?:                  string;
  confirmationValidation?:       (input: string) => boolean;
  placeholder?:                  string;
  onAccept:                     (acceptMetadata: AcceptMetadata) => void;
  onCancel?:                    () => void;
}

export const TextConfirmationModal: React.FC<TextConfirmationModalProps> =  React.memo(({
    className,
    title,
    description,
    name = 'text-confirmation-dialog-name',
    onAccept,
    onHide,
    onCancel = () => {},
    actionText = 'Confirm',
    confirmationValidation = () => true,
    placeholder = '',
    acceptMetadata,
    ...rest
  }) => {
  const { t } = useTranslation('flo-components');
  const [inputValue, setInputValue] = useState('');

  const handleConfirmationAction = () => {
    onAccept({...acceptMetadata, input: inputValue});
    setInputValue('');
    onHide();
  }

  const handleCancelAction = () => {
    setInputValue('');
    onCancel();
    onHide();
  }

  return (
    <>
      <FloModal
        {...rest}
        name           = {name}
        onHide         = {onHide}
        className      = {classnames(className, styles.root)}
        title          = {title}
        body           = { (props) => (
            <Container fluid>
              {
                _.isArray(description)
                  ? (description as string[]).map((d: string, i: number) => {
                    return (<Row className={styles.description} key={`textconfirmationdescription-${i}`}>
                      <span>{d}</span>
                    </Row>)
                  })
                  : <Row className={styles.description}>
                      <span>{description}</span>
                    </Row>
              }
                <Row>
                    <input
                      className = {styles.input}
                      type="text"
                      value = {inputValue}
                      placeholder = {placeholder}
                      onChange = {e => setInputValue(e.target.value)}
                    />
                </Row>
            </Container>
        )}
        footer        = { (props) => {
          return (
            <>
              <FloButton
                text       = {t('Cancel')}
                type       = {FloButtonType.SECONDARY}
                onClick    = {handleCancelAction}
              />
              <FloButton
                text       = {t(actionText)}
                type       = {FloButtonType.DEFAULT}
                disabled   = {!confirmationValidation(inputValue)}
                onClick    = {handleConfirmationAction}
              />
            </>
          )
        }}
      />
    </>
  );
});

export default TextConfirmationModal;
